// The privacy promise (owner, 2026-10-16), the same words wherever the landing
// makes it: the hero and the footer. "We" is Smart Manager. Service
// providers' own terms are in the Privacy Policy, so the line never speaks for
// them, and it never promises anything about encryption.
export const PRIVACY_PROMISE = "No ads. We never sell your data or train AI on it.";
